/**
 * Administración de códigos de sorteo (móvil + feria).
 */
import api from "../api/api";

/**
 * @param {{ q?: string, estado?: string, origen?: string, promociones?: string }} params
 */
export const buscarRegistrosSorteo = (params = {}) => {
    const query = {};
    if (params.q?.trim()) query.q = params.q.trim();
    if (params.estado && params.estado !== "TODOS") query.estado = params.estado;
    if (params.origen && params.origen !== "TODOS") query.origen = params.origen;
    if (params.promociones) query.promociones = params.promociones;
    return api.get("/admin/sorteo/registros", { params: query });
};

/** GET /api/admin/sorteo/resumen */
export const obtenerResumenSorteo = () => api.get("/admin/sorteo/resumen");

/**
 * @param {{ origen: string, sourceId: number }} payload
 */
export const validarRegistroSorteo = (payload) =>
    api.post("/admin/sorteo/registros/validar", payload);
